import React from 'react'
import tw from 'twin.macro'

export const Title = ({ children }) => <p css={tw`text-xl md:text-2xl leading-tight tracking-tight font-medium text-tellow-gray-800 items-start mb-2`}>{children}</p>
